import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "p-top__inner" };
const _hoisted_2 = { class: "p-top__left" };
const _hoisted_3 = { class: "p-topInput" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", {
    id: "userId",
    "data-user-id": "1"
}, null, -1);
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", {
    id: "stringCount",
    style: { "display": "none" }
}, null, -1);
const _hoisted_7 = { class: "p-topBtns" };
const _hoisted_8 = { class: "js-count" };
const _hoisted_9 = { id: "js-ai-max-length" };
const _hoisted_10 = { class: "p-topBtns__btnsWrap" };
const _hoisted_11 = { class: "p-topBtns__btns" };
const _hoisted_12 = ["data-tippy-content"];
const _hoisted_13 = ["disabled"];
const _hoisted_14 = ["src"];
const _hoisted_15 = { class: "" };
const _hoisted_16 = ["src"];
const _hoisted_17 = { class: "u-pc" };
const _hoisted_18 = ["src"];
const _hoisted_19 = { class: "u-pc" };
const _hoisted_20 = ["src"];
const _hoisted_21 = { class: "u-pc" };
const _hoisted_22 = {
    key: 0,
    class: "fa-solid fa-spinner",
    style: { "margin-right": "1rem" }
};
const _hoisted_23 = ["src"];
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("button", {
    type: "button",
    id: "stop-speech",
    style: { "display": "none" },
    class: "p-topBtns__btn--footerNav"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa-solid fa-volume-xmark" }),
    /*#__PURE__*/ _createTextVNode(" 止める ")
], -1);
const _hoisted_25 = { class: "p-topBtns__btns" };
const _hoisted_26 = { class: "" };
const _hoisted_27 = {
    type: "button",
    class: "p-topBtns__btn--footerNavGray js-dialog-custom-btn",
    id: "js-setting-dialog"
};
const _hoisted_28 = ["src"];
const _hoisted_29 = { class: "" };
const _hoisted_30 = {
    class: "p-topBtns__btn--footerNavGold",
    title: "自動置換がONになっています。設定を確認してください。",
    id: "js-submit"
};
const _hoisted_31 = ["src"];
const _hoisted_32 = { class: "p-top__right" };
const _hoisted_33 = { class: "p-top__rightInner" };
const _hoisted_34 = { class: "p-topTab--fixed" };
const _hoisted_35 = {
    class: "u-mgLeft--5 u-mgBottom--5 u-mgTop--5",
    id: "js-result-counter",
    style: { "color": "#666666" }
};
const _hoisted_36 = { class: "p-topTab" };
const _hoisted_37 = {
    class: "is-active p-topTab__trigger js-tabKick js-tabHook",
    id: "js-lint-tab"
};
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_39 = {
    id: "js-lint-counter",
    class: "p-topTab__counter"
};
const _hoisted_40 = {
    class: "p-topTab__trigger js-tabKick",
    id: "js-ai-tab"
};
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_42 = {
    id: "js-ai-counter",
    class: "p-topTab__counter"
};
const _hoisted_43 = {
    class: "p-topLoadingMin js-ai-loading",
    id: "js-ai-loading"
};
const _hoisted_44 = { class: "p-topLoadingMinSpinner" };
const _hoisted_45 = ["src"];
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("span", { class: "p-topLoadingMin__txt" }, "AI処理中", -1);
const _hoisted_47 = { class: "p-topResult" };
const _hoisted_48 = {
    class: "p-topTab__contents",
    id: "js-result-content"
};
const _hoisted_49 = {
    class: "p-topTab__content js-tabCont",
    id: "js-lint-content"
};
const _hoisted_50 = {
    class: "p-topResultList",
    id: "result"
};
const _hoisted_51 = ["data-rule_idx", "data-rule_id", "data-rule_dtl_id", "data-unique_id"];
const _hoisted_52 = { class: "p-topResultRules" };
const _hoisted_53 = {
    key: 0,
    class: "p-topResultRules__label"
};
const _hoisted_54 = {
    class: "c-inputCheckbox__labe",
    "data-tippy-content": "同一ルールは全て一括修正されます。",
    "data-placement": "top"
};
const _hoisted_55 = ["data-rule_id", "data-unique_id", "data-lint_type"];
const _hoisted_56 = ["innerHTML"];
const _hoisted_57 = { key: 1 };
const _hoisted_58 = ["innerHTML"];
const _hoisted_59 = { class: "p-topResultRules__bottom" };
const _hoisted_60 = { class: "p-topIgnore" };
const _hoisted_61 = ["data-unique_id"];
const _hoisted_62 = ["href"];
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("span", null, "ユーザー辞書に登録されています。", -1);
const _hoisted_64 = [
    _hoisted_63
];
const _hoisted_65 = ["href"];
const _hoisted_66 = /*#__PURE__*/ _createElementVNode("span", null, "クライアント辞書に登録されています。", -1);
const _hoisted_67 = [
    _hoisted_66
];
const _hoisted_68 = {
    key: 2,
    class: "p-topIgnore__link",
    style: { "color": "#000", "cursor": "default" }
};
const _hoisted_69 = ["href"];
const _hoisted_70 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa-solid fa-pen-to-square",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_71 = [
    _hoisted_70
];
const _hoisted_72 = {
    class: "p-topTab__content js-tabCont",
    id: "js-ai-content"
};
const _hoisted_73 = {
    class: "p-topResultList",
    id: "result2"
};
const _hoisted_74 = ["data-rule_idx"];
const _hoisted_75 = { class: "p-topResultAI" };
const _hoisted_76 = { class: "p-topResultAI__text" };
const _hoisted_77 = { class: "p-topResultAI__list" };
const _hoisted_78 = /*#__PURE__*/ _createElementVNode("dt", { class: "p-topResultAI__dt" }, "理由", -1);
const _hoisted_79 = { class: "p-topResultAI__dd" };
const _hoisted_80 = { class: "p-topResultList__btn js-tabBtn" };
import { ref, onMounted, nextTick } from '@vue/runtime-core';
import 'floating-vue/dist/style.css';
//components
import LintLoading from '../components/LintLoading.vue';
import PreviewModal from '../components/PreviewModal.vue';
import FixPreviewModal from '../components/FixPreviewModal.vue';
//composables
import { useCountDownLoading } from '../composables/useCountDownLoading';
import { useTextLength } from '../composables/useTextLength';
import { useMain } from '../composables/useMain';
import { usePointOutCounter } from '../composables/usePointOutCounter';
import { useIgnoreRule } from '../composables/useIgnoreRule';
import { usePreviewModal } from '../composables/usePreviewModal';
import { useFixPreviewModal } from '../composables/useFixPreviewModal';
import { useFontChanger } from '../composables/useFontChanger';
//classes
import TextFormatter from '../classes/TextFormatter';
import ProofeadText from '../classes/ProofeadText';
import EventHandler from '../classes/EventHandler';
//utils
import { pasteTextAndFormat, manageCustomPlaceholders, resetTextAreaOnEmptyInput, copyToClipboard, insertBrTextDivs, generateSpeech, addNewLines, countProofreadTextLength, convertEditableDomToText, setupFullSelectionCopyFix, } from '../utils/helper';
import axios from 'axios';
import { RuleType } from '../@types/rule-type';
const initeText = `<div><p class="placeholder" style="display: block;">
ここに文章を入力するか貼り付けてください。「校正する」ボタンを押すとHANZOが校正を開始します。<br>
設定ボタンで、文字置換などの設定をおこなえます。<br>
校正結果は右枠に表示されます。校正・AIタブで校正結果を確認してください。<br>
新しく別の文章を校正する際は、「クリア」ボタンを押して現状までの内容を削除してください。<br><br>
※文章生成モードへ切り替えたい場合は、上部の「文章生成」をクリックしてください。
</p></div>`;
export default /*#__PURE__*/ _defineComponent({
    __name: 'MainPage',
    props: {
        user: {},
        getTimeUrl: {},
        storeTimeUrl: {},
        createTlintrcUrl: {},
        createFixtlintrcUrl: {},
        rulePaths: {},
        ruleConfigs: {},
        topUrl: {},
        clientId: {}
    },
    setup(__props) {
        const props = __props;
        console.log(props.ruleConfigs.fixableMap);
        window.addEventListener('beforeunload', function (e) {
            e.preventDefault();
            e.returnValue = '';
            return "ページを離れようとしています。本当に離れますか？";
        });
        const { targetText, fixCounter, updateFixCounter, resetFixCounter, } = useMain();
        const { changeFont } = useFontChanger();
        const updateText = (text) => {
            const inputArea = document.getElementById('text');
            if (!inputArea)
                return;
            inputArea.innerHTML = text;
        };
        const { ignoreRuleIds, ignoreAutoFixIds, addIgnoreRuleId, hideLintResult, removePointOutSpan, resetIgnoreRuleIds, } = useIgnoreRule();
        const { lintErrorPointCounter, gptErrorPointCounter, totalErrorPointCounter, updateLintErrorPointCounter, decrementLintErrorPointCounter, updateGptErrorPointCounter, resetErrorPointCounter } = usePointOutCounter();
        const { textLength, maxTextLength, textCounterClass, setTextLength, } = useTextLength(props.user.max_text_limit);
        const { isOpen, openPreviewModal, closePreviewModal, exportDocx, } = usePreviewModal();
        const { fixStatus, openFixPreviewModal, closeFixPreviewModal, } = useFixPreviewModal();
        const { fetchStartLoading, startLoading, startCountDownLoading, endLoading, loading } = useCountDownLoading();
        const aiErrorPointsInfo = ref({});
        const lintErrorPointsInfo = ref({});
        const initLintStatus = () => {
            aiErrorPointsInfo.value = {};
            lintErrorPointsInfo.value = {};
            resetErrorPointCounter();
            resetFixCounter();
        };
        //途中で処理を中断する為のfunction
        const stopSignal = ref(new AbortController());
        const cancelLint = () => {
            // キャンセル処理の実装
            stopSignal.value.abort();
            endLoading();
        };
        const saveElapsedTime = async (proofreadTextLength, startedAt) => {
            try {
                const elapsedTime = Number(((Date.now() - startedAt) / 1000).toFixed(2));
                await axios.post(props.storeTimeUrl, {
                    type: 'both',
                    word_length: proofreadTextLength,
                    time: elapsedTime,
                });
            }
            catch (e) {
                console.error('処理時間の保存に失敗しました', e);
            }
        };
        /**
         * テキストを校正する
         */
        const execLint = async (options) => {
            const startedAt = Date.now();
            try {
                const textArea = document.getElementById('text');
                if (!textArea)
                    return;
                let text = convertEditableDomToText(textArea);
                const proofreadTextLength = countProofreadTextLength(text);
                const skipMaxLengthCheck = options?.skipMaxLengthCheck ?? false;
                if (!skipMaxLengthCheck && proofreadTextLength > maxTextLength) {
                    alert('文字数が上限を超えています');
                    return;
                }
                else if (proofreadTextLength === 0) {
                    alert('校正を実行する文章が入力されていません');
                    return;
                }
                const storedInputText = sessionStorage.getItem('proofTexts');
                if (storedInputText == null) {
                    sessionStorage.setItem('proofTexts', text);
                }
                // 改行を保持する対策(brタグを挿入)
                insertBrTextDivs(textArea);
                //初期化
                initLintStatus();
                // ローディング開始
                fetchStartLoading(props.getTimeUrl, {
                    type: 'both',
                    num: proofreadTextLength,
                });
                //.textlintの設定ファイルを作成し、自動修正を実行するルールを取得
                const settings = await fetchSettings();
                // 取得したルールを元に、テキストを修正
                const formattedText = formatText(textArea, settings);
                // 事前修正したテキストを元に、校正を実行(span挿入を含む)
                const lintResults = await performLinting(textArea, formattedText, stopSignal.value.signal);
                //既に処理が中断されている場合は、処理を終了
                if (stopSignal.value.signal.aborted) {
                    endLoading();
                    removeSpanTag();
                    stopSignal.value = new AbortController();
                    return;
                }
                aiErrorPointsInfo.value = lintResults.aiErrorPointsInfo;
                lintErrorPointsInfo.value = lintResults.lintErrorPointsInfo;
                nextTick(() => {
                    // 校正結果をUIに反映
                    updateUIWithResults(textArea, lintResults);
                    // テキストエリアの行数を調整
                    addNewLines('text');
                    // 文字数カウント更新
                    setTextLength('text');
                    saveElapsedTime(proofreadTextLength, startedAt);
                });
            }
            catch (error) {
                if (error.hasOwnProperty('response') && error.response.hasOwnProperty('status')) {
                    if (error.response.status === 419 || error.response.status === 401) {
                        alert('セッションが切れました。再度ログインしてください。');
                        location.reload();
                    }
                }
                console.error(error);
            }
            finally {
                stopSignal.value = new AbortController();
            }
        };
        const updateUIWithResults = (textArea, lintResults) => {
            const { finalErrorAnalysis, lintCounter, gptCounter } = lintResults;
            updateLintErrorPointCounter(lintCounter);
            updateGptErrorPointCounter(gptCounter);
            const eventHandler = new EventHandler(textArea);
            eventHandler.attachEventOfResultElement('js-result-element', finalErrorAnalysis);
            eventHandler.attachEventOfPointOutSpan('js-point-out-span', finalErrorAnalysis);
            eventHandler.attachErrorClickIgnoreBtn('js-ignore-error', (uniqueId) => addIgnoreRuleId(uniqueId), (uniqueId) => hideLintResult(uniqueId), (uniqueId) => removePointOutSpan(uniqueId), () => decrementLintErrorPointCounter(), (count) => updateFixCounter(count));
            eventHandler.attachEventOfFixCheckBox('js-fix-flg', (count) => updateFixCounter(count));
            endLoading();
        };
        const performLinting = async (textArea, formattedText, signal) => {
            const linter = new ProofeadText(textArea, formattedText, props.user);
            return linter.execLint(props.rulePaths, props.ruleConfigs, props.clientId, ignoreRuleIds.value, signal);
        };
        const formatText = (textArea, settings) => {
            const converter = new TextFormatter(settings.data);
            const rawText = convertEditableDomToText(textArea);
            return converter.execConvert(rawText);
        };
        const fetchSettings = async () => {
            await axios.post(props.createTlintrcUrl);
            return axios.post(props.createFixtlintrcUrl, {
                ids: [],
                userid: props.user.id,
                applyFixBeforeLint: true
            });
        };
        onMounted(() => {
            const textArea = document.getElementById('text');
            const generateText = sessionStorage.getItem('generate_text');
            sessionStorage.removeItem('generate_text');
            if (generateText && textArea) {
                textArea.innerHTML = generateText;
                setTextLength('text');
            }
            manageCustomPlaceholders('.p-topInput__inner', 'placeholder', 'data-placeholder');
            textArea?.addEventListener('paste', (event) => {
                pasteTextAndFormat(event, textArea);
                setTextLength('text');
            });
            textArea?.addEventListener('input', () => resetTextAreaOnEmptyInput(textArea));
            textArea?.addEventListener('keyup', (event) => setTextLength('text'));
            setupFullSelectionCopyFix('text');
            // speechManager('text','start-speech','stop-speech');
            window.addEventListener('proofread-file-imported', handleProofreadFileImported);
        });
        const removeSpanTag = () => {
            const inputArea = document.getElementById('text');
            const PREG_TEXT = /<span(.|\s)*?>/gi;
            if (!inputArea)
                return;
            let check_text = inputArea.innerHTML;
            const errorNumber = document.getElementsByClassName('js-error-number');
            for (let i = 0; i < errorNumber.length; i++) {
                errorNumber[i].remove();
            }
            if (PREG_TEXT.test(check_text)) {
                let tes = inputArea.innerHTML.replace(/<span(.|\s)*?>/gi, '');
                inputArea.innerHTML = tes.replace(/<\/span>/gi, '');
                let element = document.getElementsByClassName('ui-tooltip ui-corner-all ui-widget-shadow ui-widget ui-widget-content');
                for (let i = 0; i < element.length; i++) {
                    element[i].remove();
                }
            }
        };
        const returnToInitialState = () => {
            const inputArea = document.getElementById('text');
            if (!inputArea)
                return;
            let initInputText = initeText;
            if (window.confirm("校正結果もクリアされますが、よろしいでしょうか。")) {
                sessionStorage.removeItem('proofTexts');
                for (let i = 0; i < 40; i++) {
                    initInputText += '<div></div>';
                }
                inputArea.innerHTML = initInputText;
                aiErrorPointsInfo.value = {};
                lintErrorPointsInfo.value = {};
                textLength.value = 0;
                resetErrorPointCounter();
                resetIgnoreRuleIds();
                resetFixCounter();
            }
        };
        const clearResults = () => {
            aiErrorPointsInfo.value = {};
            lintErrorPointsInfo.value = {};
            resetErrorPointCounter();
            resetFixCounter();
            removeSpanTag();
        };
        const speechPending = ref(false);
        let currentAudioIndex = 0;
        let isStopped = false;
        let currentAudio = null;
        // 読み上げボタンをクリックした時の処理
        const handleSpeech = () => {
            const textArea = document.getElementById('text');
            const startSpeechBtn = document.getElementById('start-speech');
            const stopSpeechBtn = document.getElementById('stop-speech');
            const apiBaseUrl = props.rulePaths.lintBaseUrl;
            const userId = props.user.id;
            const clientId = props.clientId;
            if (textArea && startSpeechBtn && stopSpeechBtn) {
                generateSpeech(textArea, startSpeechBtn, stopSpeechBtn, maxTextLength, apiBaseUrl, userId, clientId, speechPending, currentAudioIndex, isStopped, currentAudio);
            }
            else {
                console.error("textArea, startSpeechBtn, stopSpeechBtnが取得できませんでした");
            }
        };
        const handleProofreadFileImported = (e) => {
            const customEvent = e;
            const rawText = customEvent.detail?.text ?? '';
            const textArea = document.getElementById('text');
            if (!textArea)
                return;
            // 改行処理
            const normalized = rawText.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            // HTMLエスケープ（タグを文字として表示）
            const escapeHtml = (str) => str.replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
            // スペース保持（先頭スペース含む）
            const convertSpace = (str) => escapeHtml(str).replace(/ /g, '&nbsp;').replace(/　/g, '&#x3000;');
            const importedHtml = normalized
                .split('\n')
                .map(line => `<div>${line === '' ? '<br>' : convertSpace(line)}</div>`)
                .join('');
            textArea.innerHTML = importedHtml;
            addNewLines('text');
            setTextLength('text');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(LintLoading, {
                    loading: _unref(loading),
                    "top-url": props.topUrl,
                    onCancel: cancelLint
                }, null, 8, ["loading", "top-url"]),
                _withDirectives(_createVNode(PreviewModal, {
                    "close-modal": _unref(closePreviewModal),
                    "on-export": () => _unref(exportDocx)(props.rulePaths.previewExportDocxUrl),
                    "is-proofread-export-enabled": props.user.client.is_proofread_export_enabled
                }, null, 8, ["close-modal", "on-export", "is-proofread-export-enabled"]), [
                    [_vShow, _unref(isOpen)]
                ]),
                _createVNode(FixPreviewModal, {
                    "fix-status": _unref(fixStatus),
                    "save-user-fix-history-url": props.rulePaths.saveUserFixHistoryUrl,
                    "rule-configs": props.ruleConfigs,
                    "close-modal": _unref(closeFixPreviewModal),
                    onUpdate: updateText,
                    onExecLint: execLint,
                    onResetFixCounter: _unref(resetFixCounter)
                }, null, 8, ["fix-status", "save-user-fix-history-url", "rule-configs", "close-modal", "onResetFixCounter"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", {
                                class: "p-topInput__inner js-editable",
                                id: "text",
                                name: "text",
                                contenteditable: "true",
                                "data-placeholder": "ここに文章を入力するか貼り付けてください。「校正する」ボタンを押すとHANZOが校正を開始します。<br>設定ボタンで、文字置換などの設定をおこなえます。<br> 校正結果は右枠に表示されます。校正・AIタブで校正結果を確認してください。<br>新しく別の文章を校正する際は、「クリア」ボタンを押して現状までの内容を削除してください。<br><br>※文章生成モードへ切り替えたい場合は、上部の「文章生成」をクリックしてください。",
                                innerHTML: _unref(targetText)
                            }, null, 8, _hoisted_5),
                            _hoisted_6
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("p", {
                                class: _normalizeClass(["p-topBtns__count u-mgRight--10", _unref(textCounterClass)])
                            }, [
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(textLength)), 1),
                                _createElementVNode("span", _hoisted_9, "/" + _toDisplayString(_unref(maxTextLength)) + "文字", 1)
                            ], 2),
                            _createElementVNode("form", {
                                id: "form",
                                method: "POST",
                                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event) => (execLint()), ["prevent"]))
                            }, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", {
                                            "data-tippy-content": !_ctx.user.client.is_proofread_import_enabled ? 'プランのアップグレードが必要です' : null,
                                            "data-placement": "bottom"
                                        }, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "p-topBtns__btn--footerNav js-dialog-file-import-btn",
                                                disabled: !_ctx.user.client.is_proofread_import_enabled
                                            }, [
                                                _createElementVNode("img", {
                                                    src: props.topUrl + '/images/common/icon/icon_12.svg',
                                                    alt: "",
                                                    class: "p-topBtns__btnIcon"
                                                }, null, 8, _hoisted_14),
                                                _createTextVNode(" ファイル読込 ")
                                            ], 8, _hoisted_13)
                                        ], 8, _hoisted_12),
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "p-topBtns__btn--footerNav",
                                                id: "js-text-clear",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (returnToInitialState()))
                                            }, [
                                                _createElementVNode("img", {
                                                    src: props.topUrl + '/images/common/icon/icon_08.svg',
                                                    alt: "",
                                                    class: "p-topBtns__btnIcon"
                                                }, null, 8, _hoisted_16),
                                                _createTextVNode(" クリア ")
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_17, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "p-topBtns__btn--footerNav",
                                                id: "js-copy",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (_unref(copyToClipboard)('text')))
                                            }, [
                                                _createElementVNode("img", {
                                                    src: props.topUrl + '/images/common/icon/icon_07.svg',
                                                    alt: "",
                                                    class: "p-topBtns__btnIcon"
                                                }, null, 8, _hoisted_18),
                                                _createTextVNode(" コピー ")
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "p-topBtns__btn--footerNav",
                                                id: "js-preview",
                                                onClick: _cache[2] || (_cache[2] = ($event) => (_unref(openPreviewModal)('text', 'js-before-preview', 'js-after-preview')))
                                            }, [
                                                _createElementVNode("img", {
                                                    src: props.topUrl + '/images/common/icon/icon_13.svg',
                                                    alt: "",
                                                    class: "p-topBtns__btnIcon"
                                                }, null, 8, _hoisted_20),
                                                _createTextVNode(" プレビュー ")
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "p-topBtns__btn--footerNav",
                                                id: "start-speech",
                                                onClick: handleSpeech
                                            }, [
                                                (_unref(speechPending))
                                                    ? (_openBlock(), _createElementBlock("i", _hoisted_22))
                                                    : (_openBlock(), _createElementBlock("img", {
                                                        key: 1,
                                                        src: props.topUrl + '/images/common/icon/icon_10.svg',
                                                        alt: "",
                                                        class: "p-topBtns__btnIcon"
                                                    }, null, 8, _hoisted_23)),
                                                _createTextVNode(" 読み上げ ")
                                            ]),
                                            _hoisted_24
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("button", _hoisted_27, [
                                                _createElementVNode("img", {
                                                    src: props.topUrl + '/images/common/icon/icon_14.svg',
                                                    alt: "",
                                                    class: "p-topBtns__btnIcon",
                                                    style: { "width": "25px" }
                                                }, null, 8, _hoisted_28),
                                                _createTextVNode(" 設定 ")
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                            _createElementVNode("button", _hoisted_30, [
                                                _createElementVNode("img", {
                                                    src: props.topUrl + '/images/common/icon/icon_01.svg',
                                                    alt: "",
                                                    class: "p-topBtns__btnIcon",
                                                    style: { "width": "25px" }
                                                }, null, 8, _hoisted_31),
                                                _createTextVNode(" 校正する ")
                                            ])
                                        ])
                                    ])
                                ])
                            ], 32)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("p", _hoisted_35, "結果：" + _toDisplayString(_unref(totalErrorPointCounter)) + "個", 1),
                                _createElementVNode("ul", _hoisted_36, [
                                    _createElementVNode("li", _hoisted_37, [
                                        _createTextVNode(" 校正"),
                                        _hoisted_38,
                                        _createElementVNode("span", _hoisted_39, " (" + _toDisplayString(_unref(lintErrorPointCounter)) + ") ", 1)
                                    ]),
                                    _createElementVNode("li", _hoisted_40, [
                                        _createTextVNode(" AI"),
                                        _hoisted_41,
                                        _createElementVNode("span", _hoisted_42, " (" + _toDisplayString(_unref(gptErrorPointCounter)) + ") ", 1)
                                    ])
                                ])
                            ]),
                            _createElementVNode("p", _hoisted_43, [
                                _createElementVNode("span", _hoisted_44, [
                                    _createElementVNode("img", {
                                        src: _ctx.topUrl + '/images/common/bg-loading.png',
                                        alt: "",
                                        class: "p-topLoadingMinSpinner__border"
                                    }, null, 8, _hoisted_45)
                                ]),
                                _hoisted_46
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("ul", _hoisted_50, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lintErrorPointsInfo), (rule, order) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    class: "p-topResultList__item lint js-result-element",
                                                    "data-rule_idx": order,
                                                    "data-rule_id": rule.ruleId,
                                                    "data-rule_dtl_id": rule.ruleDtlId,
                                                    "data-unique_id": rule.uniqueId,
                                                    "data-rule_type": "lint"
                                                }, [
                                                    _createElementVNode("div", _hoisted_52, [
                                                        (rule.fixableFlg)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                                _createElementVNode("label", _hoisted_54, [
                                                                    _createElementVNode("input", {
                                                                        class: "c-inputCheckbox js-fix-flg",
                                                                        type: "checkbox",
                                                                        "data-rule_id": rule.ruleId,
                                                                        "data-unique_id": rule.uniqueId,
                                                                        "data-lint_type": rule.ruleType
                                                                    }, null, 8, _hoisted_55)
                                                                ]),
                                                                _createElementVNode("span", {
                                                                    class: "js-error-message u-text--preWrap",
                                                                    style: { "font-size": "1.3rem" },
                                                                    innerHTML: rule.message
                                                                }, null, 8, _hoisted_56)
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                                _createElementVNode("p", {
                                                                    class: "p-topResultRules__text js-error-message u-text--preWrap",
                                                                    innerHTML: rule.message
                                                                }, null, 8, _hoisted_58)
                                                            ])),
                                                        _createElementVNode("div", _hoisted_59, [
                                                            _createElementVNode("div", _hoisted_60, [
                                                                _createElementVNode("button", {
                                                                    class: "p-topIgnore__btn js-ignore-error",
                                                                    type: "button",
                                                                    "data-unique_id": rule.uniqueId,
                                                                    "data-tippy-content": "同一ルールは全て一括で無視されます。",
                                                                    "data-placement": "top"
                                                                }, " 無視する ", 8, _hoisted_61),
                                                                (rule.ruleType === _unref(RuleType).USER_DIC)
                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                        key: 0,
                                                                        class: "p-topIgnore__link",
                                                                        href: _ctx.topUrl + '/user/dictionary/rule',
                                                                        target: "_blank"
                                                                    }, _hoisted_64, 8, _hoisted_62))
                                                                    : _createCommentVNode("", true),
                                                                (rule.ruleType === _unref(RuleType).CLIENT_DIC && _ctx.user.is_admin === 1)
                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                        key: 1,
                                                                        class: "p-topIgnore__link",
                                                                        href: `${_ctx.topUrl}/original_rules/detail/${rule.ruleId}`,
                                                                        target: "_blank"
                                                                    }, _hoisted_67, 8, _hoisted_65))
                                                                    : (rule.ruleType === _unref(RuleType).CLIENT_DIC && _ctx.user.is_admin === 0)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_68, "クライアント辞書に登録されています。"))
                                                                        : _createCommentVNode("", true)
                                                            ]),
                                                            (_ctx.user.is_admin)
                                                                ? (_openBlock(), _createElementBlock("a", {
                                                                    key: 0,
                                                                    href: rule.ruleUrl,
                                                                    class: "p-topResultRules__edit",
                                                                    target: "_blank"
                                                                }, _hoisted_71, 8, _hoisted_69))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ])
                                                ], 8, _hoisted_51));
                                            }), 256))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_72, [
                                        _createElementVNode("ul", _hoisted_73, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiErrorPointsInfo), (ai, order) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    class: "p-topResultList__item ai js-result-element",
                                                    "data-rule_idx": order,
                                                    "data-rule_type": "ai"
                                                }, [
                                                    _createElementVNode("div", _hoisted_75, [
                                                        _createElementVNode("p", _hoisted_76, _toDisplayString(ai.text), 1),
                                                        _createElementVNode("dl", _hoisted_77, [
                                                            _hoisted_78,
                                                            _createElementVNode("dd", _hoisted_79, _toDisplayString(ai.reason), 1)
                                                        ])
                                                    ])
                                                ], 8, _hoisted_74));
                                            }), 256))
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("button", {
                                    type: "button",
                                    id: "js-auto-fix",
                                    class: "c-btn--change02",
                                    onClick: _cache[4] || (_cache[4] = ($event) => (_unref(openFixPreviewModal)('text', _ctx.rulePaths, 'js-before-auto-fix', 'js-after-auto-fix', _ctx.user.id, _unref(ignoreAutoFixIds), _unref(startLoading), _unref(endLoading))))
                                }, "自動修正(" + _toDisplayString(_unref(fixCounter)) + ")", 1)
                            ])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
